(function () {
    "use strict";

    Components.CanvaRedirect = {
        controller: "CanvaRedirectController",
        name: "hbCanvaRedirect",
        templateUrl:
            "angular/app/modules/core/features/canva_integration/canva_redirect_page_template.html",
    };
})();
